import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Container, Card, Button, Input, TextArea, Form, FormItem, Icon, message } from '@/ui';
import { CONTACT_INFO } from '@/constants/navigation';
import { colors } from '@/theme/colors';
export const Contacts = () => {
    const [loading, setLoading] = useState(false);
    const onFinish = (values) => {
        setLoading(true);
        // Имитация отправки формы
        setTimeout(() => {
            message.success('Сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.');
            setLoading(false);
        }, 2000);
    };
    return (_jsxs(ContactsPage, { children: [_jsx(ContactsHeroSection, { children: _jsx(Container, { size: "large", children: _jsx(ContactsHeroContent, { children: _jsxs(ContactsHeroText, { children: [_jsx(ContactsHeroTitle, { children: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B" }), _jsx(ContactsHeroSubtitle, { children: "\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u043B\u044E\u0431\u044B\u043C \u0443\u0434\u043E\u0431\u043D\u044B\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043C" }), _jsx(ContactsHeroDescription, { children: "\u041D\u0430\u0448\u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u044B \u0433\u043E\u0442\u043E\u0432\u044B \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u043F\u043E\u043C\u043E\u0447\u044C \u0441 \u0432\u044B\u0431\u043E\u0440\u043E\u043C \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0438 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0437\u0430\u043A\u0430\u0437. \u0420\u0430\u0431\u043E\u0442\u0430\u0435\u043C \u0441 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A\u0430 \u043F\u043E \u043F\u044F\u0442\u043D\u0438\u0446\u0443 \u0441 9:00 \u0434\u043E 18:00." })] }) }) }) }), _jsx(ContactInfoSection, { children: _jsx(Container, { size: "large", children: _jsxs(ContactInfoGrid, { children: [_jsx(ContactInfoCard, { variant: "elevated", children: _jsxs(ContactInfoContent, { children: [_jsx(ContactInfoIcon, { children: _jsx(Icon, { type: "phone", size: 32, color: colors.primary }) }), _jsx(ContactInfoTitle, { children: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D" }), _jsx(ContactInfoMain, { children: CONTACT_INFO.phone }), _jsx(ContactInfoDescription, { children: "\u0417\u0432\u043E\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438 \u0438 \u0437\u0430\u043A\u0430\u0437\u0430" })] }) }), _jsx(ContactInfoCard, { variant: "elevated", children: _jsxs(ContactInfoContent, { children: [_jsx(ContactInfoIcon, { children: _jsx(Icon, { type: "mail", size: 32, color: colors.primary }) }), _jsx(ContactInfoTitle, { children: "Email" }), _jsx(ContactInfoMain, { children: CONTACT_INFO.email }), _jsx(ContactInfoDescription, { children: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C \u043F\u0438\u0441\u044C\u043C\u043E" })] }) }), _jsx(ContactInfoCard, { variant: "elevated", children: _jsxs(ContactInfoContent, { children: [_jsx(ContactInfoIcon, { children: _jsx(Icon, { type: "environment", size: 32, color: colors.primary }) }), _jsx(ContactInfoTitle, { children: "\u0410\u0434\u0440\u0435\u0441" }), _jsx(ContactInfoMain, { children: CONTACT_INFO.address }), _jsx(ContactInfoDescription, { children: "\u041F\u0440\u0438\u0435\u0437\u0436\u0430\u0439\u0442\u0435 \u043A \u043D\u0430\u043C \u0432 \u043E\u0444\u0438\u0441" })] }) }), _jsx(ContactInfoCard, { variant: "elevated", children: _jsxs(ContactInfoContent, { children: [_jsx(ContactInfoIcon, { children: _jsx(Icon, { type: "clock", size: 32, color: colors.primary }) }), _jsx(ContactInfoTitle, { children: "\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B" }), _jsx(ContactInfoMain, { children: CONTACT_INFO.workingHours }), _jsx(ContactInfoDescription, { children: "\u0421\u0443\u0431\u0431\u043E\u0442\u0430 \u0438 \u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435 - \u0432\u044B\u0445\u043E\u0434\u043D\u044B\u0435" })] }) })] }) }) }), _jsx(ContactFormSection, { children: _jsx(Container, { size: "large", children: _jsxs(ContactFormContent, { children: [_jsx(ContactFormContainer, { children: _jsxs(ContactFormCard, { variant: "elevated", children: [_jsxs(ContactFormHeader, { children: [_jsx("h2", { children: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C" }), _jsx("p", { children: "\u0417\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0443, \u0438 \u043C\u044B \u0441\u0432\u044F\u0436\u0435\u043C\u0441\u044F \u0441 \u0432\u0430\u043C\u0438 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F" })] }), _jsxs(Form, { onSubmit: onFinish, className: "contact-form", children: [_jsxs(FormRow, { children: [_jsx(FormItemHalf, { children: _jsx(FormItem, { name: "name", label: "\u0412\u0430\u0448\u0435 \u0438\u043C\u044F", required: true, children: _jsx(Input, { placeholder: "\u0418\u0432\u0430\u043D \u0418\u0432\u0430\u043D\u043E\u0432", size: "large" }) }) }), _jsx(FormItemHalf, { children: _jsx(FormItem, { name: "phone", label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D", required: true, children: _jsx(Input, { placeholder: "+7 (999) 123-45-67", size: "large" }) }) })] }), _jsxs(FormRow, { children: [_jsx(FormItemHalf, { children: _jsx(FormItem, { name: "email", label: "Email", required: true, children: _jsx(Input, { placeholder: "ivan@example.com", size: "large" }) }) }), _jsx(FormItemHalf, { children: _jsx(FormItem, { name: "company", label: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)", children: _jsx(Input, { placeholder: "\u041E\u041E\u041E \u0421\u0442\u0440\u043E\u0439\u041C\u0438\u0440", size: "large" }) }) })] }), _jsx(FormItem, { name: "message", label: "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435", required: true, children: _jsx(TextArea, { placeholder: "\u041E\u043F\u0438\u0448\u0438\u0442\u0435 \u0432\u0430\u0448\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0432\u043E\u043F\u0440\u043E\u0441...", rows: 4, size: "large" }) }), _jsx(FormItem, { children: _jsx(Button, { variant: "primary", size: "large", loading: loading, className: "submit-button", block: true, children: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435" }) })] })] }) }), _jsx(ContactMapContainer, { children: _jsxs(ContactMapCard, { variant: "elevated", children: [_jsxs(ContactMapHeader, { children: [_jsx("h3", { children: "\u041A\u0430\u043A \u0434\u043E\u0431\u0440\u0430\u0442\u044C\u0441\u044F" }), _jsx("p", { children: "\u041C\u044B \u043D\u0430\u0445\u043E\u0434\u0438\u043C\u0441\u044F \u0432 \u0443\u0434\u043E\u0431\u043D\u043E\u043C \u043C\u0435\u0441\u0442\u0435 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0430" })] }), _jsxs(MapPlaceholder, { children: [_jsx(MapIcon, { children: "\uD83D\uDCCD" }), _jsx(MapPlaceholderText, { children: "\u0418\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430" }), _jsx(MapAddress, { children: CONTACT_INFO.address })] }), _jsxs(TransportInfo, { children: [_jsx("h4", { children: "\u0422\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442" }), _jsxs(TransportItem, { children: [_jsx(TransportIcon, { children: "\uD83D\uDE8C" }), _jsx("span", { children: "\u0410\u0432\u0442\u043E\u0431\u0443\u0441\u044B: 15, 23, 45" })] }), _jsxs(TransportItem, { children: [_jsx(TransportIcon, { children: "\uD83D\uDE87" }), _jsx("span", { children: "\u041C\u0435\u0442\u0440\u043E: \u0441\u0442\u0430\u043D\u0446\u0438\u044F \"\u041F\u043B\u043E\u0449\u0430\u0434\u044C \u041B\u0435\u043D\u0438\u043D\u0430\"" })] }), _jsxs(TransportItem, { children: [_jsx(TransportIcon, { children: "\uD83C\uDD7F\uFE0F" }), _jsx("span", { children: "\u041F\u0430\u0440\u043A\u043E\u0432\u043A\u0430: \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F" })] })] })] }) })] }) }) }), _jsx(AdditionalContactSection, { children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u0414\u0440\u0443\u0433\u0438\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u0441\u0432\u044F\u0437\u0438" }), _jsx("p", { children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0434\u043B\u044F \u0432\u0430\u0441 \u0441\u043F\u043E\u0441\u043E\u0431" })] }), _jsxs(AdditionalContactGrid, { children: [_jsx(AdditionalContactCard, { variant: "outlined", children: _jsxs(AdditionalContactContent, { children: [_jsx(AdditionalContactIcon, { children: "\uD83D\uDCAC" }), _jsx(AdditionalContactTitle, { children: "WhatsApp" }), _jsx(AdditionalContactDescription, { children: "\u0411\u044B\u0441\u0442\u0440\u044B\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0438 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u0438" }), _jsx(Button, { variant: "primary", size: "large", block: true, children: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0432 WhatsApp" })] }) }), _jsx(AdditionalContactCard, { variant: "outlined", children: _jsxs(AdditionalContactContent, { children: [_jsx(AdditionalContactIcon, { children: "\uD83D\uDCF2" }), _jsx(AdditionalContactTitle, { children: "Telegram" }), _jsx(AdditionalContactDescription, { children: "\u041A\u0430\u043D\u0430\u043B \u0441 \u0430\u043A\u0446\u0438\u044F\u043C\u0438 \u0438 \u043D\u043E\u0432\u043E\u0441\u0442\u044F\u043C\u0438" }), _jsx(Button, { variant: "primary", size: "large", block: true, children: "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0430 \u043A\u0430\u043D\u0430\u043B" })] }) }), _jsx(AdditionalContactCard, { variant: "outlined", children: _jsxs(AdditionalContactContent, { children: [_jsx(AdditionalContactIcon, { children: "\uD83D\uDCDE" }), _jsx(AdditionalContactTitle, { children: "\u041E\u0431\u0440\u0430\u0442\u043D\u044B\u0439 \u0437\u0432\u043E\u043D\u043E\u043A" }), _jsx(AdditionalContactDescription, { children: "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u043E\u043C\u0435\u0440, \u043C\u044B \u043F\u0435\u0440\u0435\u0437\u0432\u043E\u043D\u0438\u043C" }), _jsx(Button, { variant: "primary", size: "large", block: true, children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A" })] }) })] })] }) })] }));
};
const ContactsPage = styled.div `
  min-height: 100vh;
`;
const ContactsHeroSection = styled.section `
  background: ${colors.gradientContacts};
  background-size: 400% 400%;
  animation: gradientShift 10s ease-in-out infinite;
  padding: 120px 0 80px;
  color: ${colors.textWhite};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.gradientContactsRadial};
    background-size: 200% 200%;
    animation: radialShift 15s ease-in-out infinite;
    opacity: 0.3;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.gradientContactsConic};
    background-size: 300% 300%;
    animation: conicShift 25s linear infinite;
    opacity: 0.1;
  }

  @media (max-width: 768px) {
    padding: 80px 0 60px;
  }

  @media (max-width: 480px) {
    padding: 60px 0 40px;
  }

  @keyframes gradientShift {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }

  @keyframes radialShift {
    0%, 100% { background-position: 0% 0%; }
    50% { background-position: 100% 100%; }
  }

  @keyframes conicShift {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
const ContactsHeroContent = styled.div `
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
`;
const ContactsHeroText = styled.div ``;
const ContactsHeroTitle = styled.h1 `
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;
const ContactsHeroSubtitle = styled.p `
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 24px 0;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
const ContactsHeroDescription = styled.p `
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;
const ContactInfoSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const ContactInfoGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const ContactInfoCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const ContactInfoContent = styled.div `
  padding: 20px;
`;
const ContactInfoIcon = styled.span `
  color: ${colors.primary};
  font-size: 32px;
  margin-bottom: 20px;
`;
const ContactInfoTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
`;
const ContactInfoMain = styled.p `
  font-size: 18px;
  font-weight: 500;
  color: ${colors.primary};
  margin: 0 0 8px 0;
`;
const ContactInfoDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0;
  font-size: 14px;
`;
const ContactFormSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundSecondary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const ContactFormContent = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;
const ContactFormContainer = styled.div `
  order: 1;

  @media (max-width: 768px) {
    order: 2;
  }
`;
const ContactFormCard = styled(Card) `
  height: 100%;
`;
const ContactFormHeader = styled.div `
  text-align: center;
  margin-bottom: 32px;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 12px 0;

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  p {
    color: ${colors.textSecondary};
    margin: 0;
  }
`;
const FormRow = styled.div `
  display: flex;
  gap: 16px;
  margin-bottom: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`;
const FormItemHalf = styled.div `
  flex: 1;

  @media (max-width: 768px) {
    width: 100% !important;
  }
`;
const ContactMapContainer = styled.div `
  order: 2;

  @media (max-width: 768px) {
    order: 1;
  }
`;
const ContactMapCard = styled(Card) `
  height: 100%;
`;
const ContactMapHeader = styled.div `
  text-align: center;
  margin-bottom: 24px;

  h3 {
    font-size: 24px;
    font-weight: 600;
    color: ${colors.textPrimary};
    margin: 0 0 8px 0;

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  p {
    color: ${colors.textSecondary};
    margin: 0;
  }
`;
const MapPlaceholder = styled.div `
  background: #f0f0f0;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  margin-bottom: 24px;
  border: 2px dashed ${colors.borderMedium};
`;
const MapIcon = styled.span `
  font-size: 48px;
  display: block;
  margin-bottom: 16px;
`;
const MapPlaceholderText = styled.p `
  font-size: 16px;
  color: ${colors.textSecondary};
  margin: 0 0 12px 0;
  font-weight: 500;
`;
const MapAddress = styled.span `
  font-size: 14px;
  color: #999;
  display: block;
`;
const TransportInfo = styled.div `
  h4 {
    font-size: 18px;
    font-weight: 600;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;
  }
`;
const TransportItem = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  color: ${colors.textSecondary};
`;
const TransportIcon = styled.span `
  font-size: 20px;
`;
const AdditionalContactSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  p {
    font-size: 18px;
    color: ${colors.textSecondary};
    margin: 0;
    max-width: 600px;
    margin: 0 auto;
  }
`;
const AdditionalContactGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const AdditionalContactCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const AdditionalContactContent = styled.div `
  padding: 20px;
`;
const AdditionalContactIcon = styled.div `
  font-size: 48px;
  margin-bottom: 20px;
`;
const AdditionalContactTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
`;
const AdditionalContactDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0 0 20px 0;
`;
